import { render, staticRenderFns } from "./video-player-render.vue?vue&type=template&id=27921545&"
import script from "./video-player-render.vue?vue&type=script&lang=js&"
export * from "./video-player-render.vue?vue&type=script&lang=js&"
import style0 from "./video-player-render.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports